import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createHubspotSettingsSubMenu } from "src/routing/navigation";

const HubspotSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createHubspotSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default HubspotSettingsSubMenu;
